'use client';

import { IosArrowRight } from '@sgcmpteltd/uikit-react';
import Image from 'next/image';
import Link from 'next/link';

import { joinSgcmSite } from '@/utils/url/join/public';

import { COLLAPSIBLE_ARRAOW_ICON_SIZE, NEW_CAR_SHOWCASE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const NewCarShowcase: Component = ({
  eventItem,
}) => (
  <div className={styles.containerShowEvent}>
    <div className={styles.containerCarShowCase}>

      { eventItem
        ? (
          <Image
            alt="Event image of new car showcase"
            className={styles.imageVehicleCover}
            height={146}
            src={eventItem.imgName}
            width={260} />
        )
        : (
          <div className={styles.containerImage}>
            <div
            // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: NEW_CAR_SHOWCASE }}
              className={styles.imageCarShowCase} />
          </div>
        ) }
    </div>
    <div className={styles.containerInfoContent}>
      <div className={styles.textNewCarShowcase}>
        {eventItem ? eventItem.title : 'New Car Showcase' }
      </div>
      <div className={styles.textContent}>
        Uncover the latest and upcoming cars in the market
      </div>
      <Link
        href={`${eventItem ? joinSgcmSite('/events') : joinSgcmSite('/new-cars/new-car-showcase')}`}
        target="_blank">
        <div className={styles.linkViewAllPromos}>
          View more
          <IosArrowRight
            className={styles.iconArrowRight}
            size={COLLAPSIBLE_ARRAOW_ICON_SIZE} />
        </div>
      </Link>
    </div>
  </div>
);
